'use client'
import {dollarsPrettifier} from '~/utils/dollarsPrettifier'
import {type PricingCardHeadingProps} from './types'
import {useSearchParams} from 'next/navigation'

export const HgPricingCardHeading = ({
  standardPlanNameText,
  accentPlanNameText,
  pricePerMonth,
  annualPricePerMonth,
  planDescription,
}: PricingCardHeadingProps) => {
  const searchParams = useSearchParams()
  const isMonthly = searchParams.get('pricing') === 'monthly'
  return (
    <div className="flex flex-col">
      <header className="flex flex-row items-center justify-start space-x-s2">
        <h1 className="text-text-default arcadia-heading-5">
          <span>{standardPlanNameText}</span>{' '}
          <span className="text-text-primary empty:hidden">
            {accentPlanNameText}
          </span>
        </h1>
      </header>
      <p className="text-text-subdued arcadia-subheading-5">
        {dollarsPrettifier(
          isMonthly ? pricePerMonth : annualPricePerMonth,
          true,
          'twoWhenNecessary'
        )}
        /mo.
      </p>
      <p className="pt-s2 text-text-subdued arcadia-body-3">{planDescription}</p>
    </div>
  )
}
